import React from 'react';
import { clsx } from 'clsx';
import { getChainStyle, normalizeChainLabel } from './intelVisualConfig';

type Props = {
    chain?: string | null;
    className?: string;
};

export const ChainBadge: React.FC<Props> = ({ chain, className }) => {
    const label = normalizeChainLabel(chain);
    const style = getChainStyle(chain);

    return (
        <span
            className={clsx(
                'inline-flex min-w-[2.25rem] items-center justify-center rounded-md border px-1.5 py-0.5 font-mono text-[10px] font-semibold tracking-tight',
                style.tile,
                style.text,
                className,
            )}
        >
            {label}
        </span>
    );
};
